module.exports = __webpack_public_path__ + "img/card-1.25c7b00c.svg";